var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 9.83365C2.06971 9.83365 2.66667 9.2367 2.66667 8.50032C2.66667 7.76394 2.06971 7.16699 1.33333 7.16699C0.596954 7.16699 0 7.76394 0 8.50032C0 9.2367 0.596954 9.83365 1.33333 9.83365Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 9.83365C8.73643 9.83365 9.33338 9.2367 9.33338 8.50032C9.33338 7.76394 8.73643 7.16699 8.00005 7.16699C7.26367 7.16699 6.66672 7.76394 6.66672 8.50032C6.66672 9.2367 7.26367 9.83365 8.00005 9.83365Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 9.83365C15.403 9.83365 16 9.2367 16 8.50032C16 7.76394 15.403 7.16699 14.6666 7.16699C13.9302 7.16699 13.3333 7.76394 13.3333 8.50032C13.3333 9.2367 13.9302 9.83365 14.6666 9.83365Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertIcon);
export default __webpack_public_path__ + "static/media/MoreVertIcon.c49a5d2e370c5d0efff6c1c9343d1578.svg";
export { ForwardRef as ReactComponent };